module.exports = __webpack_public_path__ + "static/media/help-circle.8d69f652.svg";